<form [formGroup]="form">
  <app-form-control [underlineInputStyle]="true">
    <div class="flex items-center gap-4">
      <div class="relative w-full">
        <input
          [formControl]="form.controls.phrase"
          appPrimengInputText
          autocomplete="off"
          class="w-full flex-1"
          pInputText
          placeholder="Szukaj produktu" />
      </div>

      <p-button
        (onClick)="handlePhraseChange()"
        appPrimengButton
        label="Szukaj"
        type="submit" />
    </div>
  </app-form-control>
</form>
